
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_299_777)"}},[_c('circle',{attrs:{"cx":"26","cy":"24","r":"22","fill":"#625A54"}})]),_c('path',{attrs:{"d":"M27.285 33.625V17.317l5.605 4.992c.13.115.28.202.441.256.162.053.332.072.5.056.34-.034.653-.21.872-.491.218-.28.323-.643.292-1.006a1.409 1.409 0 00-.46-.933l-7.713-6.875a1.514 1.514 0 00-.193-.123c-.064 0-.103-.07-.167-.097a1.213 1.213 0 00-.463-.096 1.213 1.213 0 00-.463.096c-.064 0-.103.069-.167.097a1.514 1.514 0 00-.193.123l-7.713 6.875c-.145.13-.262.291-.342.474-.08.183-.121.383-.121.585 0 .321.104.633.296.88.108.14.24.254.39.339a1.206 1.206 0 00.981.097c.161-.054.311-.142.441-.257l5.606-4.992v16.308c0 .365.135.714.376.972s.568.403.91.403c.34 0 .667-.145.908-.403s.377-.607.377-.972z","fill":"#fff"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_299_777","x":"0","y":"0","width":"52","height":"52","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_299_777"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_299_777","result":"shape"}})])])])
          )
        }
      }
    